import * as React from 'react';
import { ReactCookieProps } from 'react-cookie';

interface IProps extends ReactCookieProps {
    showCookieBanner: boolean;
    setCookieBannerVisibility(isVisible: boolean): void;
}

export class CookieBanner extends React.Component<IProps,{}> {
    public componentDidMount() {
        if (this.props.cookies) {
            const isCookieExist = this.props.cookies.get("_isVttCookieBannerHidden");
            if (isCookieExist) {
                this.props.setCookieBannerVisibility(false);
            } else {
                this.props.setCookieBannerVisibility(true);
            }
        }
      
    }
    public render() {
        const displayStyle = {
            display: "block"
        }

        const closeCookieBanner=() => {
            if (this.props.cookies) {
                this.props.cookies.set("_isVttCookieBannerHidden", "true", {path: '/', maxAge: 2592000 })
                this.props.setCookieBannerVisibility(false);
            }
        }

        return (
            this.props.showCookieBanner ?
            <div className="accept-cookies" style={displayStyle}>
                <div className="container">
                        <span className="text">
                            Käytämme verkkosivuillamme evästeitä tarjotaksemme sinulle parhaan mahdollisen käyttökokemuksen. <br /><a href="#">Tarkemmat tiedot tietosuojakäytännöistämme / evästeistä</a>.
                        </span>
                    <button className="btn" onClick={closeCookieBanner}>Hyväksy</button>
                </div>
            </div> :
            null
        );
    };
};


// WEBPACK FOOTER //
// ./src/common/components/cookieBanner/cookieBanner.tsx